import moment from "moment/moment";

const forestreeHelpers = {
    checkNull: (attr) => {
        if (attr) {
            return attr;
        } else {
            return "-";
        }
    },
    getType: (attr) => {
        if (attr === 'm') {
            return 'Works';
        } else if (attr === 'i') {
            return 'Inspection';
        } else if (attr === 'w') {
            return 'Watered';
        } else if (attr === 'c') {
            return 'Customer Request';
        } else if (attr === 'v') {
            return 'Volunteer Work';
        } else if (attr === 'vta') {
            return 'Visual Tree Assessment';
        } else if (attr === 'f') {
            return 'Tree Flagged';
        } else if (attr === 'inspection') {
            return 'Flagged for Inspection';
        } else if (attr === 'review') {
            return 'Flagged for Review';
        } else if (attr === 'tp') {
            return 'Tree Planted';
        } else {
            return "Other";
        }
    },
    activityFeedType: (attr) => {
        if (attr == "m") {
          return "Work Complete";
        } else if (attr == "i") {
          return "Inspection";
        } else if (attr == "w") {
          return "Watered";
        } else if (attr == "p") {
          return "Planted";
        } else if (attr == "s") {
          return "Tree/Stump Removed";
        } else if (attr == "c") {
          return "Data Collection";
        } else {
          return "Other";
        }
    },
    getPriority: (rid) => {
        if (rid == 1) {
            return "Low";
        } else if (rid == 2) {
            return "Medium";
        } else if (rid == 3) {
            return "High";
        } else {
            return "";
        }
    },
    getWorkTask: (taskId, tasks) => {
        if (parseInt(taskId)) {
            var length = tasks ? tasks.length : 0;
            for (var i = 0; i < length; i++) {
                if (tasks[i].id === parseInt(taskId)) {
                    return tasks[i].task;
                }
            }
        }
    },
    niceDate: (date) => {
        return moment(date).isValid() ? moment(date).format('DD/MM/YYYY') : '-';
    },
    dateTime: (date, withYear = true) => {
        if (moment(date).isValid()) {
            if (withYear) {
                return moment(date).format("DD/MM/YY, h:mma");
            } else {
                return moment(date).format("DD/MM, h:mma");
            }
        } else {
            return "-";
        }
    },
    justDate: (date) => {
        if (moment(date).isValid()) {
            return moment(date).format("DD/MM/YYYY");
        } else {
            return "-";
        }
    },
    justDateWithDash: function (date) {
        if (moment(date).isValid()) {
            return moment(date).format("YYYY-MM-DD");
        } else {
            return "-";
        }
    },
    dueDate: function (date, duration) {
        var d = duration;
        if (!duration) {
            d = 0;
        }
        if (moment(date).isValid()) {
            return moment(date).add(d, "weeks");
        } else {
            return "-";
        }
    },
    daysTo: function (date) {
        if (moment(date).isValid()) {
            let diff = moment(date).diff(moment(), "days");
            if (diff < 0) {
                return diff + " days";
            }
            return diff + " days";
        } else {
            return "-";
        }
    },
    getIcon(attr) {
        if (attr == "m") {
            return "Works";
        } else if (attr == "i") {
            return "Inspection";
        } else if (attr == "w") {
            return "Watering";
        } else if (attr == "s") {
            return "Stump";
        } else if (attr == "p") {
            return "Planting";
        } else {
            return "1";
        }
    },
    formatWorkTask(arrayString) {
        if (!arrayString || !arrayString.length) return "";
        return arrayString.substring(1, arrayString.length - 1).split(",");
    },
    parseArrayString(arrayString) {
        return arrayString.substring(1, arrayString.length - 1).split(",");
    },
    projectType(p) {
        if (p.project_type_id === 3) {
            return "Proactive Works";
        } else if (p.project_type_id === 5) {
            return "Watering";
        } else if (p.project_type_id === 7) {
            return "Inspections";
        } else if (p.project_type_id === 8) {
            return "Planting";
        } else if (p.project_type_id === 9) {
            return "Stumps";
        } else if (p.project_type_id === 10) {
            return "Works";
        } else {
            return "General";
        }
    },
    projectUrl(p) {
        if (p.project_type_id === 3) {
            return "/projects/" + p.url_link + "?projectId=" + p.url_link;
        } else if (p.project_type_id === 5) {
            return "/watering?projectId=" + p.url_link;
        } else if (p.project_type_id === 7) {
            return "/map?projectId=" + p.url_link;
        } else if (p.project_type_id === 8) {
            return "/vacant-map?projectId=" + p.url_link;
        } else if (p.project_type_id === 9) {
            return "/stumps?projectId=" + p.url_link;
        } else if (p.project_type_id === 10) {
            return "/maintenance-map?projectId=" + p.url_link;
        } else {
            return "/projects/" + p.url_link + "?projectId=" + p.url_link;
        }
    },

    groupBy(array, fn) {
        let result = {};
        array.forEach((item) => {
            let key = fn(item);
            if (!result[key]) {
                result[key] = [];
            }
            result[key].push(item);
        });
        return result;
    },
    getTreeStatus: function (sid) {
        if (sid === 1) {
            return "Planting Location";
        } else if (sid === 2) {
            return "Active";
        } else if (sid === 3) {
            return "Stump";
        } else if (sid === 4) {
            return "Removed";
        } else {
            return "NA";
        }
    },
    getStatus: function (rid) {
        if (rid === "") {
            return "Low";
        } else if (rid === "nearly due") {
            return "Medium";
        } else if (rid === "overdue") {
            return "High";
        } else {
            return "";
        }
    },
    getColour(name) {
        if (name.includes("Green")) {
            return "#4caf50";
        } else if (name.includes("Red")) {
            return "#ff5722";
        } else if (name.includes("Blue")) {
            return "#1367bf";
        } else if (name.includes("Yellow")) {
            return "#eaf31a";
        } else if (name.includes("Orange")) {
            return "#ffaa49";
        } else if (name.includes("Purple")) {
            return "#df49ff";
        } else if (name.includes("Pink")) {
            return "#ff49a9";
        } else {
            return "";
        }
    },
    getAvatarColor(username) {
        const backgroundColors = [
            '#F44336', '#FF4081', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3',
            '#03A9F4', '#00BCD4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39',
            '#FFC107', '#FF9800', '#FF5722', '#795548', '#9E9E9E', '#607D8B'
          ];
        
          if (!username) return backgroundColors[0]; // fallback
        
          const seed = username.length;
          return backgroundColors[seed % backgroundColors.length];
    },
    randomBackgroundColor (seed, colors) {
        return colors[seed % colors.length]
      },
    getRisk: function (rid) {
        if (rid == 1) {
            return "Low";
        } else if (rid == 2) {
            return "Moderate";
        } else if (rid == 3) {
            return "High";
        } else if (rid == 4) {
            return "Extreme";
        } else {
            return "-";
        }
    },
    getSize: function (sizeId) {
        switch (sizeId) {
            case 3:
                return "Large";
            case 2:
                return "Medium";
            case 1:
                return "Small";
            default:
                return "-";
        }
    },
    yearNull: function (attr) {
        if (attr) {
            return attr;
        } else {
            return "TBD";
        }
    },
    yesNo: function (attr) {
        if (attr == 1) {
            return "Yes";
        } else if (attr == 2) {
            return "No";
        } else {
            return "-";
        }
    },
    centsToDollar: function(val, dollarSign = true) {
        if (typeof val !== 'number' || isNaN(val)) return '$0.00';
        return (dollarSign ? '$' : '') + (val / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
};

export default forestreeHelpers;
